import AreaOfStudyTypeDomainService from "../../../Domain/AreaOfStudyType/AreaOfStudyType.service";
import makeAreaOfStudyLookup from "./AreaOfStudyLookup";
const MajorLookup = makeAreaOfStudyLookup(AreaOfStudyTypeDomainService.MAJOR_ID);
export default MajorLookup;
